/*
 * PD Money (GRG-55) — shared money helpers for the bundle configurator
 * (assets/pd-bundle-options.js) and the variant tiles (assets/pd-variant-tiles.js).
 *
 * Both components compute price deltas + totals from the LIVE selection, so they
 * must format raw cents into the shop's money format at runtime — Liquid only
 * handles the first paint. This is the single source of truth for that formatting;
 * there is no global Shopify.formatMoney on the page to reuse.
 *
 * Exposed on window so both deferred component scripts can call it. Load this
 * BEFORE them: each component's connectedCallback runs synchronously when its
 * customElements.define() executes, so window.pdFormatMoney must already exist.
 */
(function () {
  if (window.pdFormatMoney) return;

  // Format an integer number of cents using a Shopify money_format string
  // (e.g. "${{amount}}", "{{amount_no_decimals}} AUD").
  function pdFormatMoney(cents, moneyFormat) {
    cents = Number(cents) || 0;
    const fmt = moneyFormat || '${{amount}}';
    const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;

    function withDelimiters(number, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands == null ? ',' : thousands;
      decimal = decimal == null ? '.' : decimal;
      if (isNaN(number)) return '0';
      number = (number / 100).toFixed(precision);
      const parts = number.split('.');
      const dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      const centsPart = parts[1] ? decimal + parts[1] : '';
      return dollars + centsPart;
    }

    const match = fmt.match(placeholderRegex);
    const placeholder = match ? match[1] : 'amount';
    let value;
    switch (placeholder) {
      case 'amount_no_decimals':
        value = withDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = withDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = withDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_with_space_separator':
        value = withDelimiters(cents, 2, ' ', ',');
        break;
      case 'amount_with_apostrophe_separator':
        value = withDelimiters(cents, 2, "'", '.');
        break;
      default:
        value = withDelimiters(cents, 2);
    }
    return fmt.replace(placeholderRegex, value);
  }

  // Signed delta label relative to the current selection, e.g. "+$0.00", "-$199.00".
  function pdSignedDelta(deltaCents, moneyFormat) {
    if (deltaCents === 0) return '+' + pdFormatMoney(0, moneyFormat);
    const sign = deltaCents > 0 ? '+' : '-';
    return sign + pdFormatMoney(Math.abs(deltaCents), moneyFormat);
  }

  window.pdFormatMoney = pdFormatMoney;
  window.pdSignedDelta = pdSignedDelta;
})();
